import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import Pagination from '../../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import { Loader } from '../../components/ModalsCommonFunctions';
import { CModal } from '@coreui/react';

const HostelStudentInchargeMapping = () => {
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const sectionMasterId = localStorage.getItem("sectionMasterId")
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()

    const [hostelInchargeMasterId, setHostelInchargeMasterId] = useState("")
    const [InchargeList, setInchargeList] = useState([])
    const [studentList, setStudentList] = useState([])
    const [showDetails, setShowDetails] = useState("");
    const [visible, setVisible] = useState(false);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [nameSort, setNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["studentMasterDetails.studentId", "studentMasterDetails.studentName", "studentMasterDetails.email", "studentMasterDetails.primaryContact"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getStudentList(hostelInchargeMasterId)
        }
    }, [searchValue]);


    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (hostelInchargeMasterId !== '') {
                setCurrPage(1);
                setStudentList(await searchArray("B", `/get-hostel-incharge-student-mapping-list?hostelInchargeMasterId=${hostelInchargeMasterId}`, searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(studentList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(studentList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > studentList.length) {
            endIndex = studentList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(studentList.slice(startIndex, endIndex));
    }, [studentList, currPage, itemsPerPage]);

    const getInchargeList = () => {
        const apiUrl = `/get-hostel-incharge?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setInchargeList(response.data.result)
            })
            .catch(error => {
                setInchargeList([])
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getStudentList = async (hostelInchargeMasterId) => {
        const apiUrl = `/get-hostel-incharge-student-mapping-list?hostelInchargeMasterId=${hostelInchargeMasterId}`;
        try {
            const response = await authorizedAxiosSection.get(apiUrl)
            setStudentList(response.data.result)
        } catch (error) {
            setStudentList([])
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    useEffect(() => {
        getInchargeList()
    }, [])

    const handleHostelInchargeChange = (e) => {
        const { name, value } = e.target;
        setHostelInchargeMasterId(value);
        getStudentList(value)
    }

    const handleReset = () => {
        setHostelInchargeMasterId("");
        setStudentList([]);
        setNameSort(null);
    }


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Student Incharge Mapping</span></li>
                        </ol>
                    </nav>
                </div>
                <div id='scroll-up'></div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-users-cog"></i>Student Incharge Mapping</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label for="hostelInchargeMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Incharge :</label>
                                                    <select class="form-select" aria-label="Default select example" name='hostelInchargeMasterId' onChange={handleHostelInchargeChange} value={hostelInchargeMasterId}>
                                                        <option selected value={''} disabled>Select Incharge</option>
                                                        {
                                                            InchargeList?.map((Incharge) => {
                                                                return <option value={Incharge.id}>{Incharge.name}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    <button className="btn btn-danger delete_icon delete-icon " type="reset" onClick={handleReset}>Reset</button>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">Student Id</th>
                                                                        <th scope="col">
                                                                            Student Name
                                                                            <SortIcon sortState={nameSort} setSortState={setNameSort} setData={setStudentList} setCurrPage={setCurrPage} sortingPath={"studentMasterDetails.studentName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Email
                                                                        </th>
                                                                        <th scope="col" className='ins_id'>Phone No</th>
                                                                        <th scope="col">Full Details</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((student, index) => {
                                                                                const { studentMasterDetails } = student;
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{studentMasterDetails.studentId}</td>
                                                                                        <td>{studentMasterDetails.studentName}</td>
                                                                                        <td>{studentMasterDetails.email}</td>
                                                                                        <td>{studentMasterDetails.primaryContact}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setShowDetails(studentMasterDetails);
                                                                                                setVisible(!visible)
                                                                                            }}><i class="fa fa-eye" ></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Student Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={studentList.length} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />

            {visible && <CModal
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="LiveDemoExampleLabel"
                onIni
            >
                <div className="book book-modal">
                    <h2 className='table-header-like'>Full Details</h2>
                    <div className='page'>
                        <p>Student Id: {showDetails.studentId}</p>
                        <p>Student Name: {showDetails.studentName}</p>
                        <p>Date of Birth: {showDetails.dob}</p>
                        {showDetails.address && <p>Address: {showDetails.address}</p>}
                        {showDetails.state && <p>State: {showDetails.state}</p>}
                        {showDetails.district && <p>District: {showDetails.district}</p>}
                        {showDetails.city && <p>City: {showDetails.city}</p>}
                        {showDetails.pincode && <p>Pincode: {showDetails.pincode}</p>}
                        {showDetails.primaryContact && <p>Contact Number I: {showDetails.primaryContact}</p>}
                        {showDetails.secondaryContact && <p>Contact Number II: {showDetails.secondaryContact}</p>}
                        <p>Email: {showDetails.email}</p>
                    </div>
                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                        Close
                    </button>
                </div>
            </CModal>}
        </>
    )
};

export default HostelStudentInchargeMapping;